import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import ChapterPage from './pages/ChapterPage';
import RegulationPage from './pages/RegulationPage';
import MockExamPage from './pages/MockExamPage';
import QCodesPage from './pages/QCodesPage';
import BandsPage from './pages/BandsPage';
import RSTPage from './pages/RSTPage';
import ResistorsPage from './pages/ResistorsPage';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/chapter/:chapterId" element={<ChapterPage />} />
          <Route path="/regulation/:regulationId" element={<RegulationPage />} />
          <Route path="/mock-exam" element={<MockExamPage key="v1" />} />
          <Route path="/mock-exam-v2" element={<MockExamPage key="v2" examVersion="v2" />} />
          <Route path="/qcodes-quiz" element={<QCodesPage />} />
          <Route path="/bands-quiz" element={<BandsPage />} />
          <Route path="/rst-quiz" element={<RSTPage />} />
          <Route path="/resistors-quiz" element={<ResistorsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;